import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material';
import { environment } from '../../../environments/environment';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import { storage } from '@tabletuck/firebase-services';

import FacebookIcon from '@mui/icons-material/Facebook';
import '../Menu/index.css';
import footer from '../../../assets/career.png';
import { Box } from '@mui/system';
import { Field, Formik } from 'formik';
import * as yup from 'yup';
import { firestore } from '../../../../../../libs/firebase-service/src';
import CustomPhoneNumber from '../../components/PhoneNumber/PhoneInput';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datePicker.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchData, handleToaster } from '../../Utils/UtilsFunctions';
import { Helmet } from 'react-helmet';
import en from 'date-fns/locale/en-US';
import ar from 'date-fns/locale/ar';
import es from 'date-fns/locale/es';
import ch from 'date-fns/locale/zh-CN';
import he from 'date-fns/locale/he';
import moment from 'moment';
import PhoneInternational from '../../components/PhoneNumber/phoneinternational';
import { startsWithPlus } from '../CheckoutPage/utils';
import SectionHeader from '../../components/common/SectionHeader';
function Careers() {
  const [t, i18n] = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [url, setUrl] = React.useState('');
  const [error, setErr] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [file, setFile] = useState('');
  const re = /\S+@\S+\.\S+/;
  const pattern = /^[a-zA-Z0-9]+@[a-zA-Z0-9.]+$/;

  const handleSubmit = async (values) => {
    setIsLoadingSubmit(true);
    const doc = await firestore.collection('careers').doc();
    const updateDoc = await firestore.collection('restaurant').doc();
    let phoneNumbert = values.phoneNumber;
    
    try {
      if (url.length > 0) {
        setErr('');
        
        // Save career form data
        await firestore
          .collection('careers')
          .doc(doc.id)
          .set({
            fullName: values.fullName,
            position: values.position,
            phoneNumber: phoneNumbert,
            message: values.message,
            email: values.email,
            workHours: values.workHours,
            DateToStart: startDate,
            resume: url,
            id: doc.id,
            createdAt: new Date(),
          });

        // Update restaurant document
        await firestore
          .collection('restaurant')
          .doc('Restaurant')
          .set(
            {
              update_items_id: updateDoc.id,
            },
            { merge: true }
          );

        // Send email and show toast
        await fetchData(
          `${environment?.apiUrl}/sendEmail?restaurantId=${environment.restaurantId}`,
          'post',
          {
            type: 'careers',
            id: doc.id,
          }
        )
          .then((c) => {
            setFile(null);
            console.log(c);
            handleToaster('success', t('careerss.uploadedSuccessfully'));
          })
          .catch((e) => {
            console.log('api error catch', e);
            handleToaster('error', t('errorTryAgain'));
          });

        // Reset form after successful submission
        values.fullName = '';
        values.position = '';
        values.phoneNumber = '';
        values.message = '';
        values.email = '';
        values.workHours = '';
        setUrl('');
      } else {
        setErr(t('careerss.pleaseUploadYourResume'));
      }
    } catch (e) {
      console.log('err:', e);
      handleToaster('error', t('errorTryAgain'));
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const deleteImage = () => {
    if (file) {
      const storageRef = storage.ref(`/careers/${file}`);
      storageRef
        .delete()
        .then(() => {

          setFile(null);
        })
        .catch((error) => {
          console.error('Error deleting image: ', error);
        });
    }
  };
  const handleImagrUrl = (e) => {
    setErr('');
    let file = Object.values(e.target.files)[0];
    
    // Handle case when no file is selected (user cancelled)
    if (!file) {
      return;
    }
    
    // Validate that the file is a PDF
    if (file.type !== 'application/pdf') {
      setErr(t('careerss.uploadPdfOnly', { defaultValue: 'Please upload PDF files only.' }));
      return;
    }
    
    setIsLoading(true);
    setFile(file?.name);
    
    const uploadTask = storage.ref(`/careers/${file.name}`).put(file);
    uploadTask.on(
      'state_changed',
      (snapShot) => {},
      (err) => {
        console.log(err);
        setErr(t('careerss.uploadError', { defaultValue: 'Failed to upload file. Please try again.' }));
        setIsLoading(false);
      },
      () => {
        storage
          .ref('careers')
          .child(file.name)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            setUrl(fireBaseUrl);
            setIsLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setErr(t('careerss.uploadError', { defaultValue: 'Failed to upload file. Please try again.' }));
            setIsLoading(false);
          });
      }
    );
  };

  const validationScheme = yup.object().shape({
    fullName: yup
      .string()
      .trim()
      .matches(
        /^[A-Za-z\s]+$/,
        t('careerss.nameShouldContainOnlyLettersAndSpaces')
      )
      .min(3, t('careerss.minCharMustEqual3'))
      .max(30, t('careerss.maxCharMustEqual30'))
      .required(`${t('careerss.nameErr')}`),
    position: yup
      .string()
      .matches(/^\S*$/, t('careerss.stringShouldnotContainSpaces'))
      .min(3, t('careerss.minCharMustEqual3'))
      .max(30, t('careerss.maxCharMustEqual30'))
      .required(`${t('careerss.positionErr')}`),
    message: yup
      .string()
      .matches(/^(?!\s*$).*/, t('careerss.shouldnotContainOnlySpaces'))
      .min(3, t('careerss.minCharMustEqual3'))
      .max(250, t('careerss.maxCharMustEqual250'))
      .required(`${t('contactUs.messageErr')}`),

    email: yup
      .string()
      .required(`${t('careerss.emailErr')}`)
      .email(`${t('careerss.pleaseProvideValidEmail')}`),
    phoneNumber: yup
      .string()
      .required(`${t('careerss.phoneErr')}`)
      .test('is-plus-one', `${t('validNumber')}`, function (value) {
        if (value && value.startsWith('+1')) {
          return startsWithPlus(value, '+1');
        }
        if (value && value.startsWith('+962')) {
          return startsWithPlus(value, '+962');
        }
        return true;
      }),
    workHours: yup
      .number()
      .max(24, t('careerss.workingHoursShouldnotExceed24hours'))
      .typeError(`${t('careerss.workNumber')}`)
      .required(`${t('careerss.workErr')}`)
      .min(1),
  });
  const getLocale = (language) => {
    switch (language) {
      case 'ar':
        return ar; // Return Arabic locale
      case 'es':
        return es; // Return Spanish locale
      case 'ch':
        return ch; // Return Chinese locale
      case 'he':
        return he; // Return Hebrew locale
      default:
        return en; // Return English locale as default
    }
  };
  moment.locale(i18n.language);
  const formatDate = (date) => {
    return moment(date).format(
      i18n.language === 'ar' ? 'YYYY/MM/DD' : 'MM/DD/YYYY'
    );
  };
  return (
    <>
      {environment?.restaurantId === 'istanbulDk' ||
        (environment.restaurantId === 'taqwasbakery' && (
          <Helmet>
            <title>Taqwa's Bakery and Restaurant | Careers</title>
          </Helmet>
        ))}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {environment.restaurantId === 'istanbulDk' && (
        <img
          alt="tesxt"
          height="90%"
          src={footer} // use normal <img> attributes as props
          width="100%"
        />
      )}
      {(environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty') && (
        <SectionHeader
          title="join team"
          breadcrumbs={[
            { label: 'Home', path: '/' },
            { label: 'join team', current: true },
          ]}
          fontFamily="Jost"
          showBreadcrumbs={true}
          titleVariant="h2"
          customStyles={{
            title: { fontSize: '40px', fontWeight: '700' },
            container: { minHeight: '250px' },
          }}
        />
      )}

      <Box
        width={{ xs: '95%', sm: '90%', md: '85%' }}
        sx={{
          margin: '0 auto',
          boxShadow: '0px 0px 50px 0px #45454526',
          borderRadius: '16px',
          padding: { xs: '16px', sm: '20px', md: '32px' },
          my: 5,
          position: 'relative',
          mt: { xs: '-10px', md: '-45px' },
          zIndex: 7,
          backgroundColor: 'white',
        }}
      >
        <Formik
          initialValues={{
            fullName: '',
            position: '',
            phoneNumber: '',
            message: '',
            email: '',
            workHours: '',
            DateToStart: startDate,
            resume: '',
          }}
          onSubmit={handleSubmit}
          validationSchema={validationScheme}
        >
          {({
            handleBlur,
            handleChange,
            values,
            errors,
            handleSubmit,
            touched,
          }) => (
            <div>
              {environment?.restaurantId !== 'fattyPattyDev' &&
                environment?.restaurantId !== 'fattyPatty' && (
                  <>
                    <Divider />
                    <div style={{ height: '110px' }} />
                    <Grid
                      item
                      md={12}
                      xs={12}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        style={{
                          color: environment.mainColor,
                          fontFamily: `Hanalei Fill, cursive`,
                        }}
                      >
                        {t('careerss.JoinUs')}
                      </Typography>
                    </Grid>
                    <br />
                    <Grid
                      item
                      md={12}
                      xs={12}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <Typography variant="h6" style={{ color: 'black' }}>
                        {t('careerss.careersDesc')}
                      </Typography>
                    </Grid>
                  </>
                )}

              <div style={{ height: '15px' }} />
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.fullName')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={'Enter your full name'}
                    name="fullName"
                    required
                    onChange={handleChange('fullName')}
                    onBlur={handleBlur('fullName')}
                    sx={{
                      fontFamily: 'Jost, sans-serif',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontFamily: 'Jost, sans-serif',
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                          borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d0d0d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor || '#FF6B35',
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '14px 16px',
                        fontFamily: 'Jost, sans-serif',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        fontFamily: 'Jost, sans-serif',
                      },
                    }}
                    value={values.fullName}
                    error={errors.fullName && touched.fullName}
                    variant="outlined"
                  />
                  {errors.fullName && touched.fullName ? (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {errors.fullName}
                    </span>
                  ) : null}
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.email')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={'Enter your email'}
                    name="email"
                    type="email"
                    required
                    onChange={handleChange('email')}
                    onBlur={handleBlur('email')}
                    sx={{
                      fontFamily: 'Jost, sans-serif',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontFamily: 'Jost, sans-serif',
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                          borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d0d0d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '14px 16px',
                        fontFamily: 'Jost, sans-serif',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        fontFamily: 'Jost, sans-serif',
                      },
                    }}
                    value={values.email}
                    error={errors.email && touched.email}
                    variant="outlined"
                  />
                  {errors.email && touched.email ? (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {!re.test(values?.email)
                        ? t('contactUs.validName')
                        : errors.email}
                    </span>
                  ) : null}
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.phoneNumber') || 'Phone Number'}
                  </Typography>
                  <PhoneInternational
                    phoneNumber={values.phoneNumber}
                    setPhoneNumber={(value) =>
                      handleChange({ target: { name: 'phoneNumber', value } })
                    }
                    backgroundColor="white"
                    borderRadius="12px"
                  />
                  {errors.phoneNumber && touched.phoneNumber && (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {errors.phoneNumber}
                    </span>
                  )}
                </Grid>
                <Grid item md={6} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.workHours')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={' e.g. 8, 12, etc.'}
                    name="workHours"
                    type="number"
                    required
                    onChange={handleChange('workHours')}
                    onBlur={handleBlur('workHours')}
                    sx={{
                      fontFamily: 'Jost, sans-serif',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontFamily: 'Jost, sans-serif',
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                          borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d0d0d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '14px 16px',
                        fontFamily: 'Jost, sans-serif',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        fontFamily: 'Jost, sans-serif',
                      },
                    }}
                    value={values.workHours}
                    error={errors.workHours && touched.workHours}
                    variant="outlined"
                  />
                  {errors.workHours && touched.workHours && (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {errors.workHours}
                    </span>
                  )}
                </Grid>
                <Grid item md={12} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.position')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={'e.g. Chef, Waiter, etc.'}
                    name="position"
                    required
                    onChange={handleChange('position')}
                    onBlur={handleBlur('position')}
                    sx={{
                      fontFamily: 'Jost, sans-serif',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontFamily: 'Jost, sans-serif',
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                          borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d0d0d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '14px 16px',
                        fontFamily: 'Jost, sans-serif',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        fontFamily: 'Jost, sans-serif',
                      },
                    }}
                    value={values.position}
                    error={errors.position && touched.position}
                    variant="outlined"
                  />
                  {errors.position && touched.position ? (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {errors.position}
                    </span>
                  ) : null}
                </Grid>
                <Grid item md={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.startDate')}
                  </Typography>

                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 999,
                      '& .react-datepicker-wrapper': {
                        width: '100%',
                      },
                      '& .react-datepicker__input-container': {
                        width: '100%',
                      },
                      '& .react-datepicker__input-container input': {
                        width: '100%',
                        padding: '14px 16px',
                        borderRadius: '12px',
                        border: '1px solid #e0e0e0',
                        fontFamily: 'Jost, sans-serif',
                        fontSize: '16px',
                        outline: 'none',
                        transition: 'border-color 0.2s ease',
                        backgroundColor: 'white',
                        cursor: 'pointer',
                        boxSizing: 'border-box',
                      },
                      '& .react-datepicker__input-container input:hover': {
                        borderColor: '#d0d0d0',
                      },
                      '& .react-datepicker__input-container input:focus': {
                        borderColor: environment.mainColor || '#FF6B35',
                        borderWidth: '2px',
                      },
                      '& .react-datepicker__input-container input::placeholder':
                        {
                          fontFamily: 'Jost, sans-serif',
                          color: '#999',
                        },
                      // Enhanced DatePicker popup styling
                      '& .react-datepicker': {
                        fontFamily: 'Jost, sans-serif',
                        borderRadius: '16px',
                        border: 'none',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                      },
                      '& .react-datepicker__header': {
                        backgroundColor: environment.mainColor || '#FF6B35',
                        borderBottom: 'none',
                        paddingTop: '16px',
                        borderRadius: '16px 16px 0 0',
                      },
                      '& .react-datepicker__current-month': {
                        color: 'white',
                        fontFamily: 'Jost, sans-serif',
                        fontWeight: 600,
                        fontSize: '18px',
                        marginBottom: '8px',
                      },
                      '& .react-datepicker__day-names': {
                        backgroundColor: environment.mainColor || '#FF6B35',
                        paddingBottom: '8px',
                      },
                      '& .react-datepicker__day-name': {
                        color: 'white',
                        fontFamily: 'Jost, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px',
                      },
                      '& .react-datepicker__navigation': {
                        top: '20px',
                      },
                      '& .react-datepicker__navigation--previous': {
                        borderRightColor: 'white',
                      },
                      '& .react-datepicker__navigation--next': {
                        borderLeftColor: 'white',
                      },
                      '& .react-datepicker__month-container': {
                        backgroundColor: 'white',
                      },
                      '& .react-datepicker__day': {
                        color: '#333',
                        fontFamily: 'Jost, sans-serif',
                        fontWeight: 400,
                        fontSize: '14px',
                        borderRadius: '8px',
                        margin: '2px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 107, 53, 0.1)',
                          color: environment.mainColor || '#FF6B35',
                        },
                      },
                      '& .react-datepicker__day--selected': {
                        backgroundColor: environment.mainColor || '#FF6B35',
                        color: 'white',
                        fontWeight: 600,
                        '&:hover': {
                          backgroundColor: environment.mainColor || '#FF6B35',
                        },
                      },
                      '& .react-datepicker__day--today': {
                        backgroundColor: 'rgba(255, 107, 53, 0.1)',
                        color: environment.mainColor || '#FF6B35',
                        fontWeight: 500,
                      },
                      '& .react-datepicker__day--disabled': {
                        color: '#ccc',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          cursor: 'not-allowed',
                        },
                      },
                    }}
                  >
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      minDate={new Date()}
                      dateFormat="MM/dd/yyyy"
                      locale={getLocale(i18n.language)}
                      placeholderText="Select start date"
                      showPopperArrow={false}
                      popperPlacement="bottom-start"
                      popperModifiers={[
                        {
                          name: 'offset',
                          options: {
                            offset: [0, 8],
                          },
                        },
                      ]}
                    />
                  </Box>
                </Grid>
                <Grid item md={12} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#333',
                      fontFamily: 'Jost, sans-serif',
                    }}
                  >
                    {t('careerss.message')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={t('careerss.message')}
                    name="message"
                    multiline
                    rows={4}
                    required
                    onChange={handleChange('message')}
                    onBlur={handleBlur('message')}
                    sx={{
                      fontFamily: 'Jost, sans-serif',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontFamily: 'Jost, sans-serif',
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                          borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d0d0d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '14px 16px',
                        fontFamily: 'Jost, sans-serif',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        fontFamily: 'Jost, sans-serif',
                      },
                    }}
                    value={values.message}
                    error={errors.message && touched.message}
                    variant="outlined"
                  />
                  {errors.message && touched.message ? (
                    <span
                      style={{
                        marginTop: '8px',
                        color: 'red',
                        fontSize: '12px',
                        display: 'block',
                      }}
                    >
                      {errors.message}
                    </span>
                  ) : null}
                </Grid>
                <Grid item md={12} xs={12}>
                  {file && !isLoading && (
                    <Chip
                      label={file}
                      onDelete={deleteImage}
                      deleteIcon={<DeleteIcon />}
                      variant="outlined"
                      sx={{ mb: 2 }}
                    />
                  )}
                  <form onSubmit={() => {}} className="form">
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{
                        backgroundColor: '#FFF6F2',
                        color: environment.mainColor,
                        border: `2px dashed ${environment.mainColor}`,
                        borderRadius: '12px',
                        padding: '12px 24px',
                        fontFamily: 'Jost, sans-serif',
                        fontWeight: 500,
                        textTransform: 'none',
                        boxShadow: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        width: 'fit-content',
                        transition:
                          'background 0.2s, border-color 0.2s, color 0.2s',
                        '&:hover, &:focus': {
                          backgroundColor: 'rgba(255, 107, 53, 0.08)',
                          borderColor: environment.mainColor,
                          color: environment.mainColor,
                          boxShadow: 'none',
                        },
                        '& .MuiButton-startIcon': {
                          marginRight: '8px',
                        },
                      }}
                      disabled={isLoading}
                    >
                      <svg
                        style={{ marginRight: 8 }}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="1"
                          y="1"
                          width="18"
                          height="18"
                          rx="6"
                          fill="#FFF6F2"
                        />
                        <path
                          d="M10 6V14"
                          stroke={environment.mainColor}
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M6 10H14"
                          stroke={environment.mainColor}
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                      {isLoading ? `${t('careerss.loading')}` : 'Upload CV'}
                      <input
                        type="file"
                        hidden
                        accept="application/pdf"
                        onChange={(e) => {
                          handleImagrUrl(e);
                          e.target.value = null;
                        }}
                      />
                    </Button>
                  </form>
                  <Typography
                    variant="caption"
                    sx={{ color: '#666', display: 'block', mt: 1, mb: 1 }}
                  >
                    {t('careerss.uploadPdfOnly', {
                      defaultValue: 'Please upload PDF files only.',
                    })}
                  </Typography>
                  <p style={{ color: 'red' }}>{error}</p>
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mt: 4,
                  px: 2,
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={
                    isLoadingSubmit || pattern.test(values.email) != true
                  }
                  sx={{
                    backgroundColor: isLoadingSubmit
                      ? environment.mainColor
                      : environment.mainColor,
                    color: 'white',
                    borderRadius: '12px',
                    padding: '14px 32px',
                    fontFamily: 'Jost, sans-serif',
                    fontWeight: 600,
                    fontSize: '16px',
                    textTransform: 'none',
                    minWidth: '150px',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: environment.mainColor,
                      boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
                    },
                    '&:disabled': {
                      backgroundColor: isLoadingSubmit
                        ? environment.mainColor
                        : '#ccc',
                      color: isLoadingSubmit ? 'white' : '#666',
                    },
                  }}
                >
                  {isLoadingSubmit ? (
                    <>
                      <CircularProgress
                        size={20}
                        sx={{ color: 'white', mr: 1 }}
                      />
                      {t('careerss.loading')}
                    </>
                  ) : (
                    t('careerss.send')
                  )}
                </Button>
              </Box>
              <div style={{ height: '30px' }} />
            </div>
          )}
        </Formik>
      </Box>
    </>
  );
}
export default Careers;
